import { identity } from "lodash";
import * as React from "react";

import { Box, Paper, Toolbar } from "@mui/material";

import { FormNextPaneMobile, FormNextPaneMobileContent } from "@/components/molecules/FormNextPaneMobile";
import { FormMenuMobile } from "@/components/molecules/FormMenuMobile";
import { Container } from "@mui/system";
import { BusyOverlay } from "@/components/atoms/BusyOverlay";
import { FormMenuEntry } from "@/types/index";

export type ExpressFormTemplateMobileProps = {
  menuEntries: FormMenuEntry[];
  busy?: boolean;
  currentSection?: string;
  error?: string;
  nextLabel?: string;
  children: React.ReactNode;
  onNext?: () => void;
  onSectionClick: (section: string) => void;
  nestedFunc?: boolean;
  onAdd?: () => void;
  onBack?: () => void;
  addBtnLabel?: string;
  backBtnLabel?: string;
};

export const ExpressFormTemplateMobile: React.FC<ExpressFormTemplateMobileProps> = ({
  menuEntries,
  busy,
  currentSection,
  nextLabel,
  children,
  onNext,
  onSectionClick,
  nestedFunc,
  onAdd,
  onBack,
  addBtnLabel,
  backBtnLabel,
}) => {
  return (
    <BusyOverlay hidden={!busy}>
      <Box sx={{ height: "100vh" }}>
        <FormMenuMobile
          currentKey={currentSection}
          entries={menuEntries}
          onSelect={onSectionClick}
        />

        <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100%" }}>
          {/* Space for the toolbar */}
          <Toolbar />

          <Box sx={{ flex: 1 }}>
            <Container sx={{ paddingTop: "24px", paddingBottom: "24px" }}>
              <form autoComplete="off" onSubmit={onNext} className="extra-spaced no-side-padding">
                {children}
              </form>
            </Container>
          </Box>

          {/* Space for the next pane */}
          <Paper>
            <FormNextPaneMobileContent nextOnly busy={busy} onSave={identity} />
          </Paper>
        </Box>

        <FormNextPaneMobile
          nextOnly
          busy={busy}
          nextLabel={nextLabel}
          saveLabel={null}
          onNext={onNext}
          nestedFunc={nestedFunc}
          onAdd={onAdd}
          onBack={onBack}
          addBtnLabel={addBtnLabel}
          backBtnLabel={backBtnLabel}
        />
      </Box>
    </BusyOverlay>
  );
};
